import { put, takeLatest } from 'redux-saga/effects';
import { UserAPI } from 'api/user';
import { start, success } from 'data/current-user-profile';
import { logger } from 'services';
import { fetchCurrentUserProfileSagaAction } from '../actions';

function* getCurrentUserProfileSaga() {
  try {
    yield put(start());

    const profile = yield UserAPI.getProfile();

    yield put(success(profile));
  } catch (error) {
    logger.error('getProfile failed', { error });
  }
}

export const watchGetCurrentUserProfileSaga = function* (): Generator {
  yield takeLatest(
    fetchCurrentUserProfileSagaAction.type,
    getCurrentUserProfileSaga,
  );
};
